import _ from 'lodash';
export function mobileNumberMasking(mobile_number) {
    const tel = mobile_number.split('');
    return _.fill(tel, '*', 3, tel.length - 4).join('');
}
export default function getUserDisplayInfo(user) {
    if (_.isObject(user)) {
        const mobile_number = user.mobile_number ? mobileNumberMasking(user.mobile_number) : '';
        return user.nickname || user.email || mobile_number;
    }
    return '';
}
/**
 * 在有昵称的情况下获取额外的信息
 * @param {*} user
 * @returns
 */
export function getUserAdditionalDisplayInfo(user) {
    if (_.isObject(user) && user.nickname) {
        const mobile_number = user.mobile_number ? mobileNumberMasking(user.mobile_number) : '';
        return user.email || mobile_number;
    }
    return '';
}
/**
 * 排除昵称的情况下获取额外的信息
 * @param {*} user
 * @returns
 */
export function getAdditionalDisplayWithoutNickname(user) {
    if (_.isObject(user)) {
        const mobile_number = user.mobile_number ? mobileNumberMasking(user.mobile_number) : '';
        return user.email || mobile_number || user.name;
    }
    return '';
}
